import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/settings/qr-feedback',
    name: RouteName.SettingsQrFeedback,
    component: () => import('@/pages/Settings/QrFeedback.vue'),
    meta: {
      permissions: [CRMPermission.QrFeedback],
      breadcrumb: {
        label: 'Отзывы на чеках (QR)',
        parent: RouteName.Settings,
      },
    },
  },
]
